import { render, staticRenderFns } from "./ProgressTab.vue?vue&type=template&id=0bad8870&scoped=true&"
import script from "./ProgressTab.vue?vue&type=script&lang=js&"
export * from "./ProgressTab.vue?vue&type=script&lang=js&"
import style0 from "./ProgressTab.vue?vue&type=style&index=0&id=0bad8870&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bad8870",
  null
  
)

export default component.exports